import { render, staticRenderFns } from "./addTakeLook.vue?vue&type=template&id=0c7553a4&"
import script from "./addTakeLook.vue?vue&type=script&lang=js&"
export * from "./addTakeLook.vue?vue&type=script&lang=js&"
import style0 from "./addTakeLook.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports